import { toast } from "react-toastify";
import AdminRepository from "../repository/AdminRepository";
import { useState } from "react";

export const useAdmin = () => {
  const [loading, setLoading] = useState(false);

  return {
    loading,
    saveContactus: async (payload) => {
      setLoading(true);
      try {
        const response = await AdminRepository.contactus(payload);
        if (response.status === 200) {
          toast.success(response.data.message);  // Display the success message from the backend
        } else {
          toast.warn("Unexpected response status: " + response.status);
        }
      } catch (error) {
        if (error.response) {
          toast.error(error.response.data.message || "Server Error");
        } else {
          toast.error("Network Error");
        }
      } finally {
        setLoading(false);
      }
    },

    //track Visitor
    trackVisitor: async () => {
      setLoading(true);
      try {
        const response = await AdminRepository.trackVisitor();
        return response;
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    },

    //get visitors
    getVisitorCounts: async () => {
      setLoading(true);
      try {
        const response = await AdminRepository.getVisitorCounts();
        return response;
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    },

  };
};